import { makeStyles } from '@material-ui/core/styles';
import { darken, lighten } from '@material-ui/core';
import { NgpLabelValue } from '../../form/NgpLabelValue';

const useStyles = makeStyles((theme) => ({
    container: {
        border: `1px solid ${theme.palette.divider}`,
        borderColor:
            theme.palette.type === 'light'
                ? darken(theme.palette.background.paper, 0.1)
                : lighten(theme.palette.background.paper, 0.1),
        borderRadius: 6,
        backgroundColor: theme.palette.background.paper,
    },
    labelOverride: {
        textAlign: 'right',
        flexShrink: 0,
        fontSize: 12,
        width: 120,
    },
    valueOverride: {
        maxWidth: 'none',
        width: 'auto',
        fontSize: 12,
    },
}));

function formatLabel(str) {
    if (!str) return '';

    return str
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function formatValue(value) {
    if (value === null || value === undefined) {
        return '';
    }

    if (typeof value === 'object') {
        return JSON.stringify(value, null, 2);
    }

    return String(value);
}

function parseIfJsonString(value) {
    if (typeof value !== 'string') {
        return value;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return '';
    }

    const canBeJson = trimmed.startsWith('{') || trimmed.startsWith('[');
    if (!canBeJson) {
        return value;
    }

    try {
        return JSON.parse(trimmed);
    } catch (error) {
        return value;
    }
}

function normalizeEvents(details) {
    if (details === null || details === undefined || details === '') {
        return [];
    }

    const normalized = parseIfJsonString(details);

    if (Array.isArray(normalized)) {
        return normalized;
    }

    if (typeof normalized === 'object') {
        return [normalized];
    }

    return [{ details: String(normalized) }];
}

function defaultGetEventKey(event) {
    return event?.time || event?.call_id || event?.type || JSON.stringify(event || {});
}

export default function VoipKeyValueDetails({ details, getEventKey = defaultGetEventKey }) {
    const classes = useStyles();
    const events = normalizeEvents(details);

    return events.map((event) => {
        const eventKey = String(getEventKey(event));
        const entries = Object.entries(event || {});

        return (
            <div key={eventKey} className={classes.container} style={{ padding: 12 }}>
                {entries.map(([key, value]) => (
                    <NgpLabelValue
                        key={`${eventKey}-${key}`}
                        dataLabel={formatLabel(key)}
                        dataValue={formatValue(value)}
                        showIfEmpty
                        wrap
                        labelContainerClassName={classes.labelOverride}
                        dataValueClassName={classes.valueOverride}
                    />
                ))}
            </div>
        );
    });
}
